import React from 'react';
import { graphql } from 'gatsby';
import { Section } from '@zempler/theme/src/components/section/Section';
import { NestedComponentRenderer } from '../../NestedComponentRenderer';

export const NarrowSection = ({ data: { backgroundColour, components, reducePadding, id }, ...rest }) => {
  const nestedComponents = components.map((item) => {
    const { component } = item;

    return {
      ...component,
      areas: undefined
    };
  });

  return (
    <Section
      backgroundColor={backgroundColour}
      id={id ?? undefined}
      reducePadding={reducePadding}
      narrow
      {...rest}
    >
      <NestedComponentRenderer components={nestedComponents} />
    </Section>
  );
};

export const NarrowSectionQuery = graphql`
  fragment NarrowSection on UMBRACO_NarrowSectionComponentType {
    backgroundColour
    reducePadding
    id
    components {
      remoteTypeName
      component {
        __typename
        ...NestedComponents
      }
    }
  }
`;
